import { FC } from "react";

interface PlayStoreSVGProps {
    width?: number;
    height?: number;
}

const PlayStoreSVG: FC<PlayStoreSVGProps> = ({ width = 24, height = 24 }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
        >
            <circle
                cx="12"
                cy="12"
                r="11.7"
                fill="white"
                stroke="#00086D"
                stroke-width="0.6"
            />
            <path
                d="M18.9333 11.3771C18.6667 11.2438 16.2667 9.84379 16.2667 9.84379L8.06667 5.11046C7.93333 4.97712 7.66667 4.97712 7.46667 5.04379C7.46667 5.04379 7.4 5.04379 7.4 5.11046C7.13333 5.17712 7 5.44379 7 5.71046V18.3771C7 18.5771 7.13333 18.8438 7.26667 18.9105H7.33333C7.4 18.9105 7.46667 18.9771 7.53333 18.9771C7.66667 18.9771 7.8 18.9105 7.93333 18.8438C8.2 18.7105 16.2 14.0438 16.2 14.0438L18.8667 12.5105C19.1333 12.3771 19.2667 12.1771 19.2667 11.9105C19.3333 11.7105 19.2 11.4438 18.9333 11.3771ZM15.5333 10.1771L14.2 11.5105L9.26667 6.51046L15.5333 10.1771ZM7.66667 17.9771V5.91046L13.8 11.9771L7.66667 17.9771ZM9.26667 17.3105L14.2 12.3771L15.5333 13.6438C14.4667 14.3771 11.2667 16.1771 9.26667 17.3105ZM18.6 11.9771L16.1333 13.3771L14.7333 11.9771L16.2 10.5771C16.7333 10.8438 18.2 11.7105 18.6 11.9771Z"
                fill="#00086D"
            />
        </svg>
    );
};

export default PlayStoreSVG;
